import React from 'react';
import { useTranslation } from 'react-i18next';
import { Api } from 'api';
import {
  Col,
  BaseModalProps,
  Modal,
  PrimaryButton,
  SecondaryButton,
  Row,
  success,
} from '@btc-snxt/ui';

interface Props extends BaseModalProps {
  surveyId: string;
  onDelete?: () => void;
}

const ConfirmDeleteModal: React.FC<Props> = (props): JSX.Element => {
  const { t } = useTranslation();

  const handleDelete = async () => {
    let isErrorCatched = false;

    try {
      await Api.survey.survey.delete(props.surveyId);
    } catch (e: any) {
      isErrorCatched = true;
    } finally {
      props.setIsOpen(false);
      props.setIsParentModalOpen && props.setIsParentModalOpen(false);

      if (!isErrorCatched) {
        props.onDelete && props.onDelete();
        success(t('survey.delete.delete_success'));
      }
    }
  };

  return (
    <Modal
      {...props}
      title={t('common.confirmation')}
      size={'sm'}
      components={{
        Footer: () => {
          return (
            <div className={'d-flex justify-content-between'}>
              <Row>
                <Col>
                  <SecondaryButton onClick={handleDelete}>{t('common.yes')}</SecondaryButton>
                </Col>
                <Col>
                  <PrimaryButton
                    onClick={() => {
                      props.setIsOpen(false);
                    }}
                  >
                    {t('common.no')}
                  </PrimaryButton>
                </Col>
              </Row>
            </div>
          );
        },
      }}
    >
      <Row>
        <Col>{t('survey.delete.delete_confirm')}</Col>
      </Row>
    </Modal>
  );
};

export default ConfirmDeleteModal;
